import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
  bounce?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  onClick,
  bounce = true,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };
  return <button className={`
        relative overflow-hidden rounded-lg bg-primary
        px-8 py-4 font-heading text-xl font-bold text-black shadow-lg
        transition-all duration-300 hover:bg-primary-hover hover:shadow-primary/50
        active:scale-[0.98] hover:scale-[1.02]
        ${fullWidth ? 'w-full' : ''}
        ${bounce ? 'animate-bounce-soft' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-445">
      <div className="relative z-10 flex items-center justify-center gap-2" data-id="element-446">
        {children}
      </div>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent transition-transform duration-500 hover:translate-x-full" data-id="element-447" />
    </button>;
}